"use strict";

exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-overlays/~/dom-helpers/util/camelize.js
 ** module id = 1129
 ** module chunks = 0
 **/